module.exports = __webpack_public_path__ + "04_glasses_brown.19d865ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer4/04_glasses_brown.png
// module id = DUc3
// module chunks = 0